import React, { useMemo, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import "../style/styles.css";
import "../style/JobOpening.css";

const APPLY_EMAILS = "ebs.slg@gmail.com,jobs@ebssoftware.co.in";

const JOBS = [
  {
    id: 1,
    title: "Software Developer",
    department: "Development",
    type: "Full-time",
    experience: "0–3 Years",
    location: "Siliguri / On-site / Hybrid",
    summary:
      "Work on web applications, build modules, and maintain existing systems. Collaborate with QA and project teams to deliver reliable features.",
    skills: ["Dot Net (Code-behind) + C#", "PHP", "MySQL", "CodeIgniter"],
    responsibilities: [
      "Develop and maintain web applications",
      "Write clean, maintainable code",
      "Fix bugs and improve performance",
      "Coordinate with team for timelines and delivery",
    ],
    keywords: [
      "Software Developer Jobs in Siliguri",
      "Software Developer Vacancy in Siliguri",
      "Fresher Software Developer Jobs in Siliguri",
      "PHP Developer Jobs in Siliguri",
      "CodeIgniter Developer Jobs in Siliguri",
      "C# Developer Jobs in Siliguri",
      "Dot Net Developer Jobs in Siliguri",
      "MySQL Developer Jobs in Siliguri",
      "Web Developer Jobs in Siliguri",
      "Junior Software Developer Jobs",
      "Software Development Jobs in West Bengal",
      "IT Jobs in Siliguri",
    ],
  },
  {
    id: 2,
    title: "Digital Marketing",
    department: "Marketing",
    type: "Full-time",
    experience: "0–3 Years",
    location: "Siliguri / On-site",
    summary:
      "Plan and execute digital campaigns to improve brand visibility and generate leads. Track performance and optimize continuously.",
    skills: [
      "SEO basics (On-page/Off-page)",
      "Social media marketing",
      "Content planning",
      "Google tools (Analytics / Search Console) - preferred",
    ],
    responsibilities: [
      "Manage social media pages and campaigns",
      "Assist with SEO and content strategy",
      "Create and schedule posts",
      "Monitor analytics and report results",
    ],
    keywords: [
      "Digital Marketing Jobs in Siliguri",
      "Digital Marketing Vacancy in Siliguri",
      "SEO Jobs in Siliguri",
      "Social Media Marketing Jobs in Siliguri",
      "Content Marketing Jobs in Siliguri",
      "Online Marketing Jobs in Siliguri",
      "Fresher Digital Marketing Jobs",
      "SEO Executive Jobs in Siliguri",
      "Google Analytics Jobs",
      "Google Search Console Jobs",
      "Marketing Jobs in Siliguri",
      "Digital Marketing Jobs in West Bengal",
    ],
  },
  {
    id: 3,
    title: "Software Support Executive",
    department: "Support",
    type: "Full-time",
    experience: "0–3 Years",
    location: "Siliguri / On-site",
    summary:
      "Provide customer support for software products, handle tickets, and assist users with troubleshooting and basic training.",
    skills: [
      "Good communication skills",
      "Basic software troubleshooting",
      "Ticket handling / customer support mindset",
      "Willingness to learn product workflows",
    ],
    responsibilities: [
      "Handle customer issues via phone/email",
      "Track issues and escalate when needed",
      "Assist in demos/training as required",
      "Maintain support documentation",
    ],
    keywords: [
      "Software Support Jobs in Siliguri",
      "Software Support Executive Jobs in Siliguri",
      "Customer Support Jobs in Siliguri",
      "Technical Support Jobs in Siliguri",
      "IT Support Jobs in Siliguri",
      "Helpdesk Support Jobs in Siliguri",
      "Software Training Jobs in Siliguri",
      "Product Support Executive Jobs",
      "Fresher Support Jobs in Siliguri",
      "Customer Service Jobs in Siliguri",
      "Technical Support Executive Jobs",
      "Software Support Jobs in West Bengal",
    ],
  },
];

const DEPARTMENTS = [
  "All",
  ...Array.from(new Set(JOBS.map((job) => job.department))),
];

const seoKeywords = Array.from(
  new Set(
    JOBS.flatMap((job) => [
      job.title,
      job.department,
      job.type,
      job.experience,
      job.location,
      ...job.skills,
      ...job.responsibilities,
      ...(job.keywords || []),
    ])
  )
);

const relatedSearchGroups = [
  {
    title: "Software Developer Jobs",
    text:
      "EBS Software Solution offers software developer job openings in Siliguri for candidates interested in web application development, PHP, CodeIgniter, MySQL, C# and software module development.",
    terms: [
      "Software Developer Jobs in Siliguri",
      "Software Developer Vacancy in Siliguri",
      "Fresher Software Developer Jobs in Siliguri",
      "Junior Software Developer Jobs",
      "PHP Developer Jobs in Siliguri",
      "CodeIgniter Developer Jobs in Siliguri",
      "C# Developer Jobs in Siliguri",
      "Dot Net Developer Jobs in Siliguri",
      "MySQL Developer Jobs in Siliguri",
      "Web Developer Jobs in Siliguri",
      "Software Development Jobs in West Bengal",
      "IT Developer Jobs in Siliguri",
    ],
  },
  {
    title: "Digital Marketing Jobs",
    text:
      "Digital marketing job openings for candidates interested in SEO, social media marketing, content planning, campaign management and online brand promotion.",
    terms: [
      "Digital Marketing Jobs in Siliguri",
      "Digital Marketing Vacancy in Siliguri",
      "SEO Jobs in Siliguri",
      "SEO Executive Jobs in Siliguri",
      "Social Media Marketing Jobs in Siliguri",
      "Content Marketing Jobs in Siliguri",
      "Online Marketing Jobs in Siliguri",
      "Fresher Digital Marketing Jobs",
      "Google Analytics Jobs",
      "Google Search Console Jobs",
      "Marketing Jobs in Siliguri",
      "Digital Marketing Jobs in West Bengal",
    ],
  },
  {
    title: "Software Support Jobs",
    text:
      "Software support executive job openings for candidates who can handle customer support, software troubleshooting, ticket handling, product training and support documentation.",
    terms: [
      "Software Support Jobs in Siliguri",
      "Software Support Executive Jobs in Siliguri",
      "Customer Support Jobs in Siliguri",
      "Technical Support Jobs in Siliguri",
      "IT Support Jobs in Siliguri",
      "Helpdesk Support Jobs in Siliguri",
      "Product Support Executive Jobs",
      "Software Training Jobs in Siliguri",
      "Fresher Support Jobs in Siliguri",
      "Customer Service Jobs in Siliguri",
      "Technical Support Executive Jobs",
      "Software Support Jobs in West Bengal",
    ],
  },
  {
    title: "Fresher & Entry-Level IT Jobs",
    text:
      "Career opportunities for freshers and entry-level candidates looking for software, support, marketing and IT company jobs in Siliguri.",
    terms: [
      "Fresher Jobs in Siliguri",
      "Fresher IT Jobs in Siliguri",
      "Entry Level IT Jobs in Siliguri",
      "0-3 Years Experience Jobs in Siliguri",
      "Graduate Jobs in Siliguri",
      "Computer Jobs in Siliguri",
      "IT Company Jobs in Siliguri",
      "Software Company Jobs in Siliguri",
      "Private Company Jobs in Siliguri",
      "Full Time Jobs in Siliguri",
      "On-site Jobs in Siliguri",
      "Hybrid Jobs in Siliguri",
    ],
  },
  {
    title: "IT Jobs by Location",
    text:
      "EBS Software Solution provides career opportunities for candidates looking for IT, software, marketing and support jobs in Siliguri, North Bengal and West Bengal.",
    terms: [
      "Jobs in Siliguri",
      "IT Jobs in Siliguri",
      "Software Jobs in Siliguri",
      "Software Company Jobs in Siliguri",
      "IT Company Jobs in Siliguri",
      "Job Opening in Siliguri",
      "Job Vacancy in Siliguri",
      "Career in Siliguri",
      "Private Jobs in Siliguri",
      "Jobs in North Bengal",
      "IT Jobs in West Bengal",
      "Software Jobs in West Bengal",
    ],
  },
];

const JobOpening = () => {
  const [searchText, setSearchText] = useState("");
  const [department, setDepartment] = useState("All");

  const filteredJobs = useMemo(() => {
    const keyword = searchText.trim().toLowerCase();

    return JOBS.filter((job) => {
      const departmentMatch =
        department === "All" || job.department === department;

      const searchableText = [
        job.title,
        job.department,
        job.type,
        job.experience,
        job.location,
        job.summary,
        ...job.skills,
        ...job.responsibilities,
        ...(job.keywords || []),
      ]
        .join(" ")
        .toLowerCase();

      const searchMatch = keyword === "" || searchableText.includes(keyword);

      return departmentMatch && searchMatch;
    });
  }, [searchText, department]);

  const siteUrl = (process.env.REACT_APP_SITE_URL || "https://ebssoftware.co.in").replace(/\/$/, "");
  const pagePath =
    typeof window !== "undefined" && window.location && window.location.pathname
      ? window.location.pathname
      : "/job-opening";
  const pageUrl = `${siteUrl}${pagePath}`;

  const seoTitle =
    "Job Openings in Siliguri | Software Developer, Digital Marketing & Support Jobs";

  const seoDescription =
    "Explore job openings at EBS Software Solution in Siliguri for Software Developer, Digital Marketing and Software Support Executive roles. Apply for IT jobs, software jobs and fresher jobs in Siliguri.";

  const jobPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Job Openings at EBS Software Solution",
    url: pageUrl,
    description: seoDescription,
    keywords: seoKeywords.join(", "),
    about: [
      "Software Developer Jobs in Siliguri",
      "Digital Marketing Jobs in Siliguri",
      "Software Support Jobs in Siliguri",
      "IT Jobs in Siliguri",
      "Fresher Jobs in Siliguri",
    ],
    publisher: {
      "@type": "Organization",
      name: "EBS Software Solution",
      url: siteUrl,
    },
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "EBS Software Solution",
    url: siteUrl,
    email: APPLY_EMAILS,
    description:
      "EBS Software Solution offers software development, digital marketing and software support career opportunities in Siliguri, West Bengal.",
  };

  const getMailLink = (jobTitle) => {
    const subject = encodeURIComponent(`Application for ${jobTitle}`);

    const body = encodeURIComponent(`Dear EBS Software Team,

I would like to apply for the ${jobTitle} position.

Please find my updated CV attached.

Name:
Mobile:
Current Location:
Experience:
Notice Period:

Regards,`);

    return `mailto:${APPLY_EMAILS}?subject=${subject}&body=${body}`;
  };

  return (
    <main className="job-opening-page">
      <Helmet>
        <meta charSet="utf-8" />

        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords.join(", ")} />

        <link rel="canonical" href={pageUrl} />

        <meta name="robots" content="index, follow, max-image-preview:large" />
        <meta name="author" content="EBS Software Solution" />
        <meta name="language" content="English" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:site_name" content="EBS Software Solution" />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />

        <script type="application/ld+json">
          {JSON.stringify([jobPageSchema, organizationSchema])}
        </script>
      </Helmet>

      <section className="job-hero">
        <div className="job-hero-overlay"></div>

        <Container className="job-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={8}>
              <div className="job-hero-content">
                <div className="job-kicker">Career at EBS Software Solution</div>
                <h1>Job Openings in Siliguri</h1>
                <p>
                  Explore current job openings and apply to join our team in
                  Siliguri. We are looking for candidates who are eager to
                  learn, contribute and grow with our software development,
                  software support and digital marketing teams.
                </p>
              </div>
            </Col>

            <Col lg={4}>
              <div className="job-hero-card">
                <span>Apply Now</span>
                <strong>Send your updated CV</strong>
                <p>
                  Email your resume to:
                  <br />
                  <b>ebs.slg@gmail.com</b>
                  <br />
                  <b>jobs@ebssoftware.co.in</b>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="job-filter-section">
        <Container>
          <div className="job-filter-card">
            <Row className="g-3 align-items-end">
              <Col lg={8}>
                <label className="job-filter-label" htmlFor="jobSearch">
                  Search
                </label>
                <input
                  id="jobSearch"
                  className="job-search-input"
                  type="text"
                  value={searchText}
                  onChange={(event) => setSearchText(event.target.value)}
                  placeholder="Search by title, department, skills..."
                />
              </Col>

              <Col lg={4}>
                <label className="job-filter-label" htmlFor="jobDepartment">
                  Department
                </label>
                <select
                  id="jobDepartment"
                  className="job-department-select"
                  value={department}
                  onChange={(event) => setDepartment(event.target.value)}
                >
                  {DEPARTMENTS.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Col>
            </Row>
          </div>
        </Container>
      </section>

      <section className="job-list-section">
        <Container>
          <div className="job-result-header">
            <div>
              <span>Current Openings</span>
              <h2>Available Positions</h2>
            </div>

            <strong>
              {filteredJobs.length}{" "}
              {filteredJobs.length === 1 ? "Opening" : "Openings"}
            </strong>
          </div>

          {filteredJobs.length > 0 ? (
            <div className="job-card-grid">
              {filteredJobs.map((job) => (
                <article className="job-card" key={job.id}>
                  <div className="job-card-top">
                    <div>
                      <span className="job-department-badge">
                        {job.department}
                      </span>
                      <h3>{job.title}</h3>
                    </div>

                    <span className="job-type-badge">{job.type}</span>
                  </div>

                  <div className="job-meta-row">
                    <div>
                      <span>Experience</span>
                      <strong>{job.experience}</strong>
                    </div>

                    <div>
                      <span>Location</span>
                      <strong>{job.location}</strong>
                    </div>
                  </div>

                  <p className="job-summary">{job.summary}</p>

                  <div className="job-section-block">
                    <h4>Must have skills</h4>

                    <div className="job-chip-list">
                      {job.skills.map((skill) => (
                        <span key={skill}>{skill}</span>
                      ))}
                    </div>
                  </div>

                  <div className="job-section-block">
                    <h4>Responsibilities</h4>

                    <ul className="job-check-list">
                      {job.responsibilities.map((item) => (
                        <li key={item}>
                          <span>✓</span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="job-apply-box">
                    <h4>Apply Now</h4>

                    <p>
                      Click below to email your resume to:
                      <br />
                      <b>ebs.slg@gmail.com / jobs@ebssoftware.co.in</b>
                    </p>

                    <small>
                      Tip: Attach your updated CV and mention your notice period.
                    </small>

                    <a className="job-apply-btn" href={getMailLink(job.title)}>
                      Apply Now
                    </a>
                  </div>
                </article>
              ))}
            </div>
          ) : (
            <div className="job-empty-state">
              <h3>No opening found</h3>
              <p>
                Try changing the search text or department filter to view
                available positions.
              </p>
            </div>
          )}
        </Container>
      </section>

      <section className="job-corporate-keywords-section">
        <Container>
          <div className="job-corporate-keywords-head">
            <div className="job-section-label">Related Career Searches</div>
            <h2>Job openings, software jobs, digital marketing jobs and IT career search terms</h2>
            <p>
              EBS Software Solution provides career opportunities for candidates
              looking for software developer, digital marketing, software
              support, IT company and fresher job openings in Siliguri, West
              Bengal.
            </p>
          </div>

          <Row className="g-4">
            {relatedSearchGroups.map((group) => (
              <Col lg={6} key={group.title}>
                <div className="job-corporate-keyword-card">
                  <h3>{group.title}</h3>
                  <p>{group.text}</p>

                  <div className="job-corporate-keyword-list">
                    {group.terms.map((term) => (
                      <span key={term}>{term}</span>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default JobOpening;